export default __webpack_public_path__ + "static/media/telegram.747f93fd.png";